<!-- BETA-CLEANUP: delete this file once Vue 3 is the only app -->
<template>
  <div class="profile-menu-beta-promo text-primary pa-4">
    <div class="d-flex align-center">
      <BetaRocketIcon class="mr-2" />
      <span class="text-subtitle-1 font-weight-medium">New SlickCactus</span>
      <CommonChip color="primary" class="ml-2">New</CommonChip>
    </div>
    <p class="text-body-2 text-medium-emphasis mt-2 mb-3">
      A redesigned app with the same data and sign-in. We'll open it for you until you switch back from its profile menu.
    </p>
    <p v-if="releaseNote" class="text-body-2 font-weight-medium mt-n1 mb-3" data-test="beta-promo-release">
      {{ releaseNote }}
    </p>
    <v-btn
      color="primary"
      variant="flat"
      block
      append-icon="mdi-arrow-right"
      :loading="isOpeningBeta"
      data-test="open-beta"
      data-track="beta.profile-menu.open"
      @click="open"
    >
      Try the new version
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { getBetaReleaseNote, openBeta } from '@/bundles/App/helpers/betaChannel';

import BetaRocketIcon from '@/bundles/App/components/BetaRocketIcon.vue';
import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';

const releaseNote = getBetaReleaseNote();
const isOpeningBeta = ref(false);

const open = async (): Promise<void> => {
  isOpeningBeta.value = true;

  try {
    await openBeta();
  } finally {
    isOpeningBeta.value = false;
  }
};
</script>

<style lang="scss" scoped>
// a light tint of the primary colour that reads in both themes, like Vuetify's tonal alerts
.profile-menu-beta-promo {
  position: relative;
  // the copy wraps to the menu's width instead of stretching the menu
  contain: inline-size;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-color: currentColor;
    opacity: 0.08;
    pointer-events: none;
  }
}
</style>
